<template>
  <v-table class="elevation-1">
    <thead>
      <tr>
        <th v-for="header in headers" :key="header.value">{{ header.text }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="itemsPending">
        <td :colspan="headers.length" class="text-center py-4">
          <v-progress-circular indeterminate size="24" width="2" class="mr-2" />
          Loading... Please wait
        </td>
      </tr>
      <tr v-else-if="products.length === 0">
        <td :colspan="headers.length" class="text-center py-4">No data available</td>
      </tr>
      <template v-else>
      <tr v-for="item in paginatedProducts" :key="item.name" @click="$emit('click', item)" class="product_link">
        <td>
            <v-img
              height="45"
              contain
              :src="getImage(item.default_image_uuid)"
            />
        </td>
        <td>{{ item.id }}</td>
        <td>
          {{ item.name }}
        </td>
        <td>
          {{ item.product_type_name }}
        </td>
      </tr>
      </template>
    </tbody>
  </v-table>
  <table-pagination
    :page="pagination.page"
    :rows-per-page="pagination.rowsPerPage"
    :total-items="products.length"
    :rows-per-page-options="[10, 25, 50]"
    @update:page="pagination.page = $event"
    @update:rows-per-page="onRowsPerPageChange"
  />
</template>

<script>
  import _ from 'lodash';
  import helpers from '@/mixins/helpers';
  import TablePagination from "@/components/TablePagination.vue";

  export default {
    components: {
      "table-pagination": TablePagination,
    },
    props: {
      filters: {
        type: Object,
        default() {
          return { name: '', type: '' }; 
        },
      },

      rowsPerPage: {
        type: Array,
        default() {
          return [25];
        },
      },
    },

    mixins: [
      helpers,
    ],

    data() {
      return {
        pagination: {
          page: 1,
          sortBy: 'name',
          rowsPerPage: 25,
        },
        products: [],
        selected: [],
        headers: [
          { text: '', sortable: false, value: '' },
          { text: 'ID', value: 'id' },
          { text: 'Name', value: 'name' },
          { text: 'Type', value: 'product_type_name' }
        ],

        itemsPending: true,
      }
    },

    computed: {
      paginatedProducts() {
        const start = (this.pagination.page - 1) * this.pagination.rowsPerPage;
        const end = start + this.pagination.rowsPerPage;
        return this.products.slice(start, end);
      },
    },

    mounted() {
      this.loadProducts();
    },

    methods: {
      onRowsPerPageChange(val) {
        this.pagination.rowsPerPage = val;
        this.pagination.page = 1;
      },
      async loadProducts() {
        this.itemsPending = true;
        try {
          let filter_name = this.$props.filters.name ? this.$props.filters.name : null;
          let filter_type = this.$props.filters.type ? this.$props.filters.type : null;
          let result = await this.$axios.get(`/product/getProductList/${filter_name}/${filter_type}`);
          this.products = result.data;

          this.pagination.page = 1;
        } finally {
          this.itemsPending = false;
        }
      },

      applyFilter: _.debounce(function () {
        this.loadProducts();
      }, 300)
    },
  }
</script>

<style>
  .product_link {
    cursor: pointer;
  }
</style>
